<template>
	<v-card>
		<v-card-title>
			Inserisci i dati di fatturazione per questo bando
		</v-card-title>
		<v-card-text>
			<v-stepper
				v-model="stepAttuale"
				flat
			>
				<v-stepper-header
					style="box-shadow: none; border-bottom: 1px solid rgba(0,0,0,.12)"
				>
					<template v-for="step in stepsDatiDiFatturazione">
						<v-stepper-step
							:key="`${step.id}-step`"
							:complete="stepAttuale > step.id"
							:step="step.id"
						>
							<span class="font-weight-medium">
								{{ step.titolo }}
							</span>
						</v-stepper-step>
						
						<v-divider
							v-if="step.id !== stepsDatiDiFatturazione.length"
							:key="step.id"
						></v-divider>
					</template>
				</v-stepper-header>
				
				<v-stepper-items>
					<v-stepper-content
						:key="`step-1-content`"
						:step="1"
					>
						<v-row>
							<v-col>
								<div><b>Hai la RESIDENZA all'estero e sei iscritto all'AIRE? (Se hai domicilio all'estero ma residenza in Italia seleziona "No")</b></div>
								<v-radio-group
									v-model="datiDiFatturazione.residenza_estera"
									class="mt-1"
									row
								>
									<v-radio key="si" label="Si" :value="true"></v-radio>
									<v-radio key="no" label="No" :value="false"></v-radio>
								</v-radio-group>
							</v-col>
						</v-row>
					</v-stepper-content>
					
					<v-stepper-content
						:key="`step-2-content`"
						:step="2"
					>
						<v-row>
							<v-col>
								<div><b>Hai una partita IVA che vuoi utilizzare per ricevere il pagamento per questo Click Day? (Ed emettere quindi fattura?)</b></div>
								<v-radio-group
									v-model="datiDiFatturazione.possesso_partita_iva"
									class="mt-1"
									row
								>
									<v-radio key="si" label="Si" :value="true"></v-radio>
									<v-radio key="no" label="No" :value="false"></v-radio>
								</v-radio-group>
							</v-col>
						</v-row>
					</v-stepper-content>
					
					<v-stepper-content
						:key="`step-3-content`"
						:step="3"
					>
						<v-form ref="formDatiDiFatturazione">
							<v-row>
								<v-col>
									<b>Dati anagrafici</b>
								</v-col>
							</v-row>
							<v-row>
								<template v-if="!datiDiFatturazione.possesso_partita_iva">
									<v-col
										cols="4"
										class="pt-0"
									>
										<v-text-field
											v-model="datiDiFatturazione.nome"
											label="Nome"
											outlined
											dense
											:rules="[vincoli.required]"
										></v-text-field>
									</v-col>
									<v-col
										cols="4"
										class="pt-0"
									>
										<v-text-field
											v-model="datiDiFatturazione.cognome"
											label="Cognome"
											outlined
											dense
											:rules="[vincoli.required]"
										></v-text-field>
									</v-col>
									<v-col
										cols="4"
										class="pt-0"
									>
										<v-select
											v-model="datiDiFatturazione.sesso"
											:items="['M', 'F']"
											label="Sesso anagrafico"
											outlined
											dense
											:rules="[vincoli.required]"
										></v-select>
									</v-col>
									<v-col
										cols="5"
										class="pt-0"
									>
										<v-text-field
											v-if="datiDiFatturazione.residenza_estera"
											v-model="datiDiFatturazione.luogo_di_nascita"
											label="Luogo di nascita"
											outlined
											dense
											:rules="[vincoli.required]"
										></v-text-field>
										
										<v-autocomplete
											v-else-if="!datiDiFatturazione.residenza_estera"
											v-model="comunePerCFSelezionato"
											:items="comuniPerCF"
											label="Comune di Nascita o Stato Estero"
											:loading="isLoadingComuniPerCF"
											:filter="(item, queryText, itemText) => customFilterByProperties(item, queryText, ['nome', 'sigla'])"
											:rules="[vincoli.required]"
											:search-input.sync="cercaComunePerCF"
											:no-data-text="isLoadingComuniPerCF ? 'In caricamento..' : (cercaComunePerCF == null || cercaComunePerCF.length < 2 ? 'Scrivi almeno 2 lettere per cercare' : 'Comune o Stato non trovato')"
											autocomplete="off"
											return-object
											clearable
											outlined
											dense
										>
											<template v-slot:item="data">
												{{ data.item.nome }} ({{data.item.sigla}})
											</template>
											<template v-slot:selection="data">
												{{ data.item.nome }} ({{data.item.sigla}})
											</template>
										</v-autocomplete>
									</v-col>
									
									<v-col
										cols="3"
										class="pt-0"
									>
										<v-menu
											ref="menuDataDiNascita"
											v-model="menuDataDiNascita"
											:close-on-content-click="false"
											transition="scale-transition"
											offset-y
											max-width="290px"
											min-width="auto"
										>
											<template v-slot:activator="{ on, attrs }">
												<v-text-field
													:value="dateITFormatDDMMYYYY(datiDiFatturazione.data_di_nascita)"
													label="Data di nascita"
													readonly
													v-bind="attrs"
													v-on="on"
													outlined
													dense
													:rules="[vincoli.required]"
												></v-text-field>
											</template>
											<v-date-picker
												v-model="datiDiFatturazione.data_di_nascita"
												@input="menuDataDiNascita = false"
												first-day-of-week="1"
												scrollable
											></v-date-picker>
										</v-menu>
									</v-col>
									
									<v-col
										cols="4"
										class="pt-0"
									>
										<!--<v-text-field-->
										<!--	v-if="datiDiFatturazione.residenza_estera"-->
										<!--	v-model="datiDiFatturazione.codice_fiscale"-->
										<!--	label="Codice fiscale"-->
										<!--	outlined-->
										<!--	dense-->
										<!--	:rules="[vincoli.required]"-->
										<!--&gt;</v-text-field>-->
										
										<v-text-field
											v-model="datiDiFatturazione.codice_fiscale"
											:label="`Codice Fiscale ${datiDiFatturazione.codice_fiscale_manuale ? '(Manuale)' : '(Automatico)'}`"
											:readonly="!datiDiFatturazione.codice_fiscale_manuale"
											outlined
											dense
											:loading="isCalculatingCF"
											:rules="[vincoli.required]"
										>
											<template v-slot:append v-if="campiCFRiempiti && !isCalculatingCF">
												<v-tooltip bottom>
													<template v-slot:activator="{ on }">
														<v-icon
															v-on="on"
															color="primary"
															v-if="!datiDiFatturazione.codice_fiscale_manuale"
															@click="datiDiFatturazione.codice_fiscale_manuale = true"
														>
															create
														</v-icon>
														<v-icon
															v-on="on"
															color="primary"
															v-else
															@click="calcolaCFAuto()"
														>
															settings_backup_restore
														</v-icon>
													</template>
													<span v-if="!datiDiFatturazione.codice_fiscale_manuale">
														Modifica manualmente
													</span>
													<span v-else>Genera automaticamente</span>
												</v-tooltip>
											</template>
										</v-text-field>
									</v-col>
								</template>
								
								<template v-else-if="datiDiFatturazione.possesso_partita_iva">
									<v-col
										cols="12"
										class="pt-0"
									>
										<v-text-field
											v-model="datiDiFatturazione.partita_iva"
											label="Partita IVA"
											outlined
											dense
											:rules="[vincoli.required, vincoli.partita_iva]"
										></v-text-field>
									</v-col>
									<v-col
										cols="12"
										class="pt-0"
									>
										<v-text-field
											v-model="datiDiFatturazione.ragione_sociale"
											label="Ragione sociale"
											outlined
											dense
											:rules="[vincoli.required]"
										></v-text-field>
									</v-col>
								</template>
							</v-row>
							
							<v-row>
								<v-col>
									<b>Indirizzo della RESIDENZA (non del domicilio)</b>
								</v-col>
							</v-row>
							<v-row>
								<v-col
									cols="8"
									class="pt-0"
								>
									<v-text-field
										v-model="datiDiFatturazione.via"
										label="Via / Piazza"
										outlined
										dense
										:rules="[vincoli.required]"
									></v-text-field>
								</v-col>
								<v-col
									cols="4"
									class="pt-0"
								>
									<v-text-field
										v-model="datiDiFatturazione.numero_civico"
										label="Numero civico"
										outlined
										dense
										:rules="[vincoli.required]"
									></v-text-field>
								</v-col>
								<v-col
									cols="5"
									class="pt-0"
								>
									<v-text-field
										v-if="datiDiFatturazione.residenza_estera"
										v-model="datiDiFatturazione.comune"
										label="Comune"
										outlined
										dense
										:rules="[vincoli.required]"
									></v-text-field>
									
									<v-autocomplete
										v-else-if="!datiDiFatturazione.residenza_estera"
										label="Comune"
										:items="comuni"
										:value="datiDiFatturazione.comune"
										@input="datiDiFatturazione.comune = $event ? $event.comune : null"
										item-value="comune"
										item-text="comune"
										:filter="(item, queryText, itemText) => customFilterByProperties(item, queryText, ['comune', 'sigla'])"
										:search-input.sync="cercaComune"
										:loading="isLoadingComuni"
										:no-data-text="isLoadingComuni ? 'In caricamento..' : (cercaComune == null || cercaComune.length < 2 ? 'Scrivi almeno 2 lettere per cercare' : 'Comune non trovato')"
										clearable
										autocomplete="off"
										outlined
										dense
										:rules="[vincoli.required]"
										return-object
										@change="gestisciAutoCompletamentoPartendoDalComune($event)"
									>
										<template v-slot:item="data">
											{{ data.item.comune }} ({{data.item.sigla}})
										</template>
										<template v-slot:selection="data">
											{{ data.item.comune }}
										</template>
									</v-autocomplete>
								</v-col>
								<v-col
									cols="3"
									class="pt-0"
								>
									<v-select
										v-show="selezioneCapInCorso"
										ref="caps"
										item-text="codice"
										item-value="codice"
										:items="capsItems"
										v-model="datiDiFatturazione.cap"
										label="Seleziona un CAP"
										:rules="[vincoli.required]"
										outlined
										dense
									></v-select>
									<v-text-field
										v-show="!selezioneCapInCorso"
										v-model="datiDiFatturazione.cap"
										label="CAP"
										outlined
										dense
										:rules="[vincoli.required]"
									></v-text-field>
								</v-col>
								<v-col
									cols="4"
									class="pt-0"
								>
									<v-text-field
										v-if="!datiDiFatturazione.residenza_estera"
										v-model="datiDiFatturazione.provincia"
										label="Provincia"
										outlined
										dense
										:rules="[vincoli.required]"
									></v-text-field>
									
									<!--<v-text-field-->
									<!--	v-else-if="datiDiFatturazione.residenza_estera"-->
									<!--	v-model="datiDiFatturazione.stato_estero"-->
									<!--	label="Stato estero"-->
									<!--	outlined-->
									<!--	dense-->
									<!--	:rules="[vincoli.required]"-->
									<!--&gt;</v-text-field>-->
									
									<v-autocomplete
										v-else-if="datiDiFatturazione.residenza_estera"
										v-model="statoEsteroISO"
										:items="nazioni"
										label="Stato estero"
										:loading="isLoadingNazioni"
										:filter="(item, queryText, itemText) => customFilterByProperties(item, queryText, ['nome', 'iso_alpha_3'])"
										:rules="[vincoli.required]"
										:search-input.sync="cercaNazione"
										:no-data-text="isLoadingNazioni ? 'In caricamento..' : (cercaNazione == null || cercaNazione.length < 2 ? 'Scrivi almeno 2 lettere per cercare' : 'Stato non trovato')"
										autocomplete="off"
										return-object
										clearable
										outlined
										dense
									>
										<template v-slot:item="data">
											{{ data.item.nome }} {{ data.item.iso_alpha_3 !== null ? `(${ data.item.iso_alpha_3 })` : ''}}
										</template>
										<template v-slot:selection="data">
											{{ data.item.nome }} {{ data.item.iso_alpha_3 !== null ? `(${ data.item.iso_alpha_3 })` : ''}}
										</template>
									</v-autocomplete>
								</v-col>
							</v-row>
							
							<v-row>
								<v-col>
									<b>IBAN</b>
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<v-row>
										<v-col>
											<v-text-field
												outlined
												dense
												label="IBAN*"
												v-model="datiDiFatturazione.iban"
												@input="v => { datiDiFatturazione.iban = v.toUpperCase() }"
												:rules="[vincoli.required, vincoli.iban]"
											></v-text-field>
										</v-col>
									</v-row>
									<v-row class="flex-column" style="font-weight:600; font-size:16px">
										<v-col>
											<div :style="`color:${scdColor}`">È intestato a te?</div>
											<v-radio-group
												row
												v-model="ibanIntestatoAlCliccatore"
												class="mt-1"
											>
												<v-radio key="si" label="SI" :value="true"></v-radio>
												<v-radio key="no" label="NO" :value="false"></v-radio>
											</v-radio-group>
										</v-col>
									</v-row>
									<v-row v-if="ibanIntestatoAlCliccatore == false" class="mb-3">
										<v-col>
											<v-text-field
												v-model="datiDiFatturazione.intestatario_iban"
												label="Nome e Cognome dell'intestatario*"
												outlined
												dense
												:rules="[vincoli.required]"
											></v-text-field>
											<div :style="`color:${scdColor}; font-weight:500;`">
												Poiché stai usando l'IBAN di un'altra persona, devi scrivere in carta semplice una dichiarazione in cui affermi di voler ricevere il compenso sull'IBAN dell'altra persona e ponete entrambi la firma. Invia poi questa dichiarazione all'email cliccatori@clickday.it<br>(Attenzione: questa dichiarazione è necessaria per ricevere il compenso, in caso di IBAN non intestato a te)
											</div>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
						</v-form>
					</v-stepper-content>
				</v-stepper-items>
			</v-stepper>
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn
				:color="scdRed"
				class="white--text"
				rounded
				@click="$emit('close')"
				:disabled="isSavingDatiDiFatturazione"
			>
				Annulla
			</v-btn>
			<v-btn
				v-if="stepAttuale != 1"
				:color="scdColor"
				class="white--text"
				rounded
				@click="stepAttuale--"
				:disabled="isSavingDatiDiFatturazione"
			>
				Indietro
			</v-btn>
			<v-btn
				v-if="stepAttuale != stepsDatiDiFatturazione.length"
				rounded
				style="text-transform:none; color:white;"
				@click="stepAttuale++"
				:color="scdOrange"
			>
				Avanti
			</v-btn>
			<v-btn
				v-if="stepAttuale == stepsDatiDiFatturazione.length"
				rounded
				style="text-transform:none; color:white;"
				@click="salvaDatiDiFatturazione()"
				:color="scdOrange"
				:loading="isSavingDatiDiFatturazione"
			>
				Salva
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import mixin from '../../mixins';

export default {
	props: {
		// se value !== null sta ricevendo i dati del profilo cliccatore dall'esterno
		// e non devo chiamare il metodo getProfiloCliccatore() in questo componente
		value: {
			default: null
		},
		idCliccatore: {
			default: null
		},
		bandoId: {
			default: null
		}
	},
	data() {
		return {
			datiDiFatturazione: {
				nome: null,
				cognome: null,
				sesso: null,
				luogo_di_nascita: null,
				sigla_provincia_di_nascita: null,
				data_di_nascita: null,
				codice_fiscale: null,
				codice_fiscale_manuale: false,
				partita_iva: null,
				ragione_sociale: null,
				via: null,
				numero_civico: null,
				comune: null,
				cap: null,
				provincia: null,
				sigla_provincia: null,
				iban: null,
				intestatario_iban: null,
				dati_inseriti: false,
				possesso_partita_iva: false,
				residenza_estera: false,
				stato_estero: null,
				iso_alpha_3: null
			},
			stepsDatiDiFatturazione: [
				{
					id: 1,
					titolo: 'Residenza'
				},
				{
					id: 2,
					titolo: 'P.IVA'
				},
				{
					id: 3,
					titolo: 'Dati di fatturazione'
				}
			],
			stepAttuale: 1,
			pagamentoRifiutato: true,
			possessoPartitaIva: false,
			ibanIntestatoAlCliccatore: true,
			isSavingDatiDiFatturazione: false,
			
			menuDataDiNascita: false,
			
			comuni: [],
			isLoadingComuni: false,
			cercaComune: null,
			
			capsItems: [],
			selezioneCapInCorso: false,
			
			comuniPerCF: [],
			isLoadingComuniPerCF: false,
			cercaComunePerCF: null,
			comunePerCFSelezionato: { // Variabile di appoggio usata per impostare luogo_di_nascita e sigla
				nome: null,
				sigla: null,
				id: null
			},
			isCalculatingCF: false, // Se è true non permettere di proseguire!,
			
			statoEsteroISO: {
				nome: null,
				iso_alpha_3: null,
				id: null
			},
			nazioni: [],
			isLoadingNazioni: false,
			cercaNazione: null
		}
	},
	
	created() {
		Object.assign(this.datiDiFatturazione, {
			nome: this.value.nome_in_dati_di_fatturazione,
			cognome: this.value.cognome_in_dati_di_fatturazione,
			sesso: this.value.sesso,
			luogo_di_nascita: this.value.luogo_di_nascita,
			sigla_provincia_di_nascita: this.value.sigla_provincia_di_nascita,
			data_di_nascita: this.value.data_di_nascita,
			codice_fiscale: this.value.codice_fiscale,
			codice_fiscale_manuale: this.value.codice_fiscale_manuale,
			partita_iva: this.value.partita_iva,
			ragione_sociale: this.value.ragione_sociale,
			via: this.value.via,
			numero_civico: this.value.numero_civico,
			comune: this.value.comune,
			cap: this.value.cap,
			provincia: this.value.provincia,
			sigla_provincia: this.value.sigla_provincia,
			iban: this.value.iban,
			intestatario_iban: this.value.intestatario_iban,
			dati_inseriti: this.value.dati_inseriti,
			possesso_partita_iva: this.value.possesso_partita_iva,
			residenza_estera: this.value.residenza_estera,
			stato_estero: this.value.stato_estero,
			iso_alpha_3: this.value.iso_alpha_3,
		});
		
		if (this.datiDiFatturazione.intestatario_iban != null) {
			this.ibanIntestatoAlCliccatore = false;
		}
		
		// NOTA IMPORTANTE Inserisco il comune e la sigla nell'array "comuniPerCF[]" e in comunePerCFSelezionato{}.
		// Altrimenti se l'array è vuoto e/o il l'oggetto non è impostato, non comparirà
		if (this.datiDiFatturazione.luogo_di_nascita !== null) {
			this.comunePerCFSelezionato = {
				nome: this.datiDiFatturazione.luogo_di_nascita,
				sigla: this.datiDiFatturazione.sigla_provincia_di_nascita,
				id: this.datiDiFatturazione.luogo_di_nascita.concat(this.datiDiFatturazione.sigla_provincia_di_nascita)
			};
			this.comuniPerCF.push(this.comunePerCFSelezionato);
		}
		
		if (this.datiDiFatturazione.stato_estero !== null) {
			this.statoEsteroISO = {
				nome: this.datiDiFatturazione.stato_estero,
				iso_alpha_3: this.datiDiFatturazione.iso_alpha_3,
				id: this.datiDiFatturazione.stato_estero.concat(this.datiDiFatturazione.iso_alpha_3)
			};
			// this.nazioni.push(this.statoEsteroISO);
		}
		
		this.getComuni();
		
		this.$watch('datiDiFatturazione.nome', () => {
			if (!this.datiDiFatturazione.residenza_estera) {
				this.calcolaCFAuto();
			}
		});
		
		this.$watch('datiDiFatturazione.cognome', () => {
			if (!this.datiDiFatturazione.residenza_estera) {
				this.calcolaCFAuto();
			}
		});
		
		this.$watch('datiDiFatturazione.sesso', () => {
			if (!this.datiDiFatturazione.residenza_estera) {
				this.calcolaCFAuto();
			}
		});
		
		this.$watch('datiDiFatturazione.data_di_nascita', () => {
			if (!this.datiDiFatturazione.residenza_estera) {
				this.calcolaCFAuto();
			}
		});
		
		this.$watch('datiDiFatturazione.luogo_di_nascita', () => {
			if (!this.datiDiFatturazione.residenza_estera) {
				this.calcolaCFAuto();
			}
		});
	},
	
	computed: {
		campiCFRiempiti() {
			return this.datiDiFatturazione.nome != null
				&& this.datiDiFatturazione.nome != ""
				&& this.datiDiFatturazione.nome.length >= 2
				&& this.datiDiFatturazione.cognome != null
				&& this.datiDiFatturazione.cognome != ""
				&& this.datiDiFatturazione.cognome.length >= 2
				&& this.datiDiFatturazione.sesso != null
				&& this.datiDiFatturazione.sesso != ""
				&& this.datiDiFatturazione.data_di_nascita != null
				&& this.datiDiFatturazione.data_di_nascita != ""
				&& this.datiDiFatturazione.luogo_di_nascita != null
				&& this.datiDiFatturazione.luogo_di_nascita != ""
		}
	},
	
	watch: {
		'cercaComune': function (newVal) {
			if (newVal != null && newVal.length >= 2) this.getComuni(newVal);
		},
		'cercaComunePerCF': function(newVal) {
			if(newVal != null && newVal.length >= 2) this.getComuniPerCF(newVal);
		},
		'datiDiFatturazione.comune': function (newVal) {
			if (newVal === null) {
				this.selezioneCapInCorso = false;
			}
		},
		// 'datiDiFatturazione.nome': function() {
		// 	this.calcolaCFAuto();
		// },
		// 'datiDiFatturazione.cognome': function() {
		// 	this.calcolaCFAuto();
		// },
		// 'datiDiFatturazione.sesso': function() {
		// 	this.calcolaCFAuto();
		// },
		// 'datiDiFatturazione.data_di_nascita': function() {
		// 	this.calcolaCFAuto();
		// },
		// 'datiDiFatturazione.luogo_di_nascita': function() {
		// 	this.calcolaCFAuto();
		// },
		// 'datiDiFatturazione.sigla_provincia_di_nascita': function() {
		// 	// this.calcolaCFAuto(); // => No perché viene sempre chiamata già con luogo_nascita
		// },
		'comunePerCFSelezionato': {
			handler(newObj) {
				if(newObj != null){
					this.datiDiFatturazione.luogo_di_nascita = newObj.nome;
					this.datiDiFatturazione.sigla_provincia_di_nascita = newObj.sigla;
				}
			},
			deep: true
		},
		'datiDiFatturazione.codice_fiscale_manuale': function (val) {
			console.log(val)
		},
		'datiDiFatturazione.residenza_estera': function (bool) {
			console.log(bool === true && this.nazioni.length == 0);
			if (bool === true && this.nazioni.length == 0) this.getNazioni();
		},
		'statoEsteroISO': {
			handler(newObj) {
				if (newObj != null) {
					this.datiDiFatturazione.stato_estero = newObj.nome;
					this.datiDiFatturazione.iso_alpha_3 = newObj.iso_alpha_3;
				}
			}
		}
	},
	
	methods: {
		getComuni(toSearch = null) {
			this.isLoadingComuni = true;
			this.comuni = [];
			
			let params = {};
			if (toSearch != null) params.search = toSearch;
			
			axios.get('/comuni', {
				params: params
			})
				.then(response => {
					this.comuni = response.data.map(comune => {
						return {
							comune: comune.nome,
							sigla: comune.sigla,
							id: comune.id
						}
					});
				})
				.finally(() => {
					this.isLoadingComuni = false;
				});
		},
		getComuniPerCF(toSearch = null) {
			this.isLoadingComuniPerCF = true;
			this.comuniPerCF = [];
			
			let params = {};
			if (toSearch != null) params.search = toSearch;
			
			axios.get('/comuni-nazioni', {
				params: params
			})
				.then(response => {
					this.comuniPerCF = response.data.map(comune => {
						return {
							nome: comune.nome,
							sigla: comune.sigla,
							id: comune.nome.concat(comune.sigla) // Uso come ID la concat di nome e sigla
						}
					});
				})
				.finally(() => {
					this.isLoadingComuniPerCF = false;
				});
		},
		salvaDatiDiFatturazione() {
			if (this.$refs.formDatiDiFatturazione.validate()) {
				this.isSavingDatiDiFatturazione = true;
				this.datiDiFatturazione.dati_inseriti = true;
				
				axios.post(
					'/clickdayit/salva_dati_di_fatturazione',
					{
						utente_id: this.idCliccatore,
						bando_id: this.bandoId,
						dati_di_fatturazione: this.datiDiFatturazione
					}
				)
					.finally(() => {
						this.isSavingDatiDiFatturazione = false;
						this.$emit('close');
						this.$emit('salvataggio-eseguito');
					})
			}
		},
		gestisciAutoCompletamentoPartendoDalComune(comuneObj) {
			if (comuneObj !== null) {
				this.getAllByComuneId(comuneObj.id);
			}
			else {
				this.datiDiFatturazione.cap = null;
				this.datiDiFatturazione.provincia = null;
				this.datiDiFatturazione.sigla_provincia = null;
			}
			
		},
		getAllByComuneId(comuneId) {
			this.selezioneCapInCorso = false;
			
			axios.get('/all-by-comune-id', {
				params: {
					comune_id: comuneId
				}
			})
				.then(response => {
					this.datiDiFatturazione.provincia = response.data.provincia.nome;
					this.datiDiFatturazione.sigla_provincia = response.data.provincia.sigla;
					
					this.capsItems = response.data.caps;
					
					if (this.capsItems.length == 1) {
						this.datiDiFatturazione.cap = this.capsItems[0].codice;
					}
					else {
						this.datiDiFatturazione.cap = null;
						this.selezioneCapInCorso = true;
					}
				})
		},
		calcolaCFAuto: function() {
			if (this.campiCFRiempiti) {
				this.datiDiFatturazione.codice_fiscale_manuale = false;
				
				this.isCalculatingCF = true;
				
				axios.get('/codice-fiscale', {
					params: {
						nome: this.datiDiFatturazione.nome,
						cognome: this.datiDiFatturazione.cognome,
						sesso: this.datiDiFatturazione.sesso,
						data_di_nascita: this.datiDiFatturazione.data_di_nascita,
						luogo_di_nascita: this.datiDiFatturazione.luogo_di_nascita,
						sigla_provincia_di_nascita: this.datiDiFatturazione.sigla_provincia_di_nascita
					}
				})
					.then(response => {
						if(response.data.stato == 'ok'){
							this.datiDiFatturazione.codice_fiscale = response.data.codiceFiscale;
						}
						else throw "Risposta non OK da Calcolo Codice Fiscale"; // Chiama eccezione con questo testo
					})
					.finally(() => {
						this.isCalculatingCF = false;
					});
			}
		},
		getNazioni() {
			this.isLoadingNazioni = true;
			
			axios.get('/nazioni')
				.then(response => {
					this.nazioni = response.data.map(nazione => {
						return {
							nome: nazione.nome,
							iso_alpha_3: nazione.iso_alpha_3,
							id: nazione.nome.concat(nazione.iso_alpha_3) // Uso come ID la concat di nome e sigla
						}
					});
				})
				.finally(() => {
					this.isLoadingNazioni = false;
				})
		}
	}
}
</script>